<div class="container-fluid">
  <div class="row" style="padding-bottom: 1em; padding-top: 0.6em;">
    <div class="col-sm-12">
      <div *ngIf="!loading && (executedQueriesData === null || executedQueriesData.length === 0)">
        <h5 style="text-align: center; color: #ffffff;">No query history</h5>
      </div>
      <kendo-listview *ngIf="executedQueriesData !== null && executedQueriesData.length > 0" [data]="executedQueriesData" [containerClass]="'k-d-flex k-flex-col k-flex-nowrap'">
        <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
          <app-query-card class="query" [query]="dataItem">
          </app-query-card>
        </ng-template>
      </kendo-listview>
    </div>
  </div>
  <div class="row">
    <ngx-spinner [name]="'previousQueriesSpinner'" size="medium" [fullScreen]="false" type="ball-atom">
    </ngx-spinner>
  </div>
</div>
